import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import PriceListTable from "../store-data/PriceListTable";
import ErrorMessage from "../../components/ErrorMessage";
import { FORM_FIELDS } from "../../Constants";
import { useForm } from "react-hook-form";

const AddPriceListModal = ({ updateData, onHide, setStores }) => {
  const { STORE_DATA } = FORM_FIELDS;

  const [priceListFormData, setPriceListFormData] = useState([]);
  const [priceListTableData, setPriceListTableData] = useState([]);
  const [priceListInvalidRows, setPriceListInvalidRows] = useState({});

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (!updateData) return;

    setPriceListFormData(updateData?.[STORE_DATA.PRICE_LIST_DATA.name] || []);
    setPriceListTableData(updateData?.priceListTableData || []);
  }, [updateData]);

  const onSubmit = (data) => {
    setStores((stores) => {
      const index = stores.findIndex((item) => item.tag === updateData.tag);
      const newStores = [...stores];
      newStores[index] = {
        ...newStores[index],
        priceListTableData,
        priceListData: priceListFormData,
      };
      return newStores;
    });
    onHide();
  };

  return (
    <Modal
      centered
      show={!!updateData}
      onHide={onHide}
      size="lg"
      className="public-onboarding__add-store-modal"
    >
      <Modal.Header>
        Uredi cjenik prodajnog mjesta:{" "}
        {updateData?.[STORE_DATA.DESCRIPTION.name]}
      </Modal.Header>
      <div className="col-lg-12">
        <hr></hr>
        <PriceListTable
          setFormData={setPriceListFormData}
          invalidRows={priceListInvalidRows}
          setInvalidRows={setPriceListInvalidRows}
          priceListTableData={priceListTableData}
          setPriceListTableData={setPriceListTableData}
        />
        <input
          type="hidden"
          name={STORE_DATA.PRICE_LIST_DATA.name}
          ref={register({
            validate: (data) => {
              return Object.keys(priceListInvalidRows).length < 1;
            },
          })}
          value={JSON.stringify(priceListFormData)}
        />
        <ErrorMessage
          errorType={errors?.[STORE_DATA.PRICE_LIST_DATA.name]?.type}
          messages={{
            validate: "Učitajte datoteku sa ispravnim podacima.",
          }}
        />
      </div>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button onClick={handleSubmit(onSubmit)}>Spremi</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPriceListModal;
